import { Component, Vue } from 'vue-property-decorator';
import { AgGridVue } from 'ag-grid-vue';
import { GridApi, ColumnApi, GridOptions } from 'ag-grid-community';
import { OpTableConfigurator } from './util/OpTableConfigurator';
import store, { StateWithModules } from '@/store';
import { OperationalDataActionsNames } from '@/store/modules/operational-data/operational-data-actions';
import { OperationalDataModel } from '@/models/operational-data/operational-data';
import { EventBus } from '@/utils';
import { CountriesSid } from '@/utils/evt-mgmt-utils';

@Component({
    components: {
        'ag-grid-vue': AgGridVue
    }
})
export default class OperationalDataTable extends Vue {
    private gridApi: GridApi | null = null;
    private columnApi: ColumnApi | null = null;
    tableConfigurator!: OpTableConfigurator;

    get gridOptions(): GridOptions {
        return {
            ...this.tableConfigurator.gridOptions,
            onGridReady: this.onGridReady
        };
    }

    beforeMount(): void {
        this.tableConfigurator = new OpTableConfigurator();
        store.watch(
            (state: StateWithModules) => state.operationalData.filteredTableData,
            this.onTableDataChange
        );
    }

    private onTableDataChange(opData: OperationalDataModel[]): void {
        opData.forEach(entry => {
            entry.Status.Name = this.$t('operationalData.filters.statuses.' + entry.Status.Id) as string;
            entry.Country.Name = this.$t(CountriesSid[entry.Country.Id]).toString();
        });

        if (this.gridApi) {
            this.gridApi.setRowData(opData);
        }
    }

    private loadTableData(): void {
        store.dispatch(OperationalDataActionsNames.LoadAvailableStatuses)
            .then(() => store.dispatch(OperationalDataActionsNames.LoadOperationalData));
    }

    mounted(): void {
        EventBus.$on(EventBus.GLOBAL.LANGUAGE_CHANGED, () => this.onLanguageChange());
        this.loadTableData();
    }

    onLanguageChange(): void {
        if (this.gridApi) {
            this.gridApi.forEachNode(node => {
                const opDataModel = node.data as OperationalDataModel;
                opDataModel.Country.Name = this.$t(CountriesSid[opDataModel.Country.Id]).toString();
                opDataModel.Status.Name = this.$t('operationalData.filters.statuses.' + opDataModel.Status.Id) as string;
                node.setData(opDataModel);
            });

            const updatedColumnDefs = this.tableConfigurator.updateGridOptions();
            this.gridApi.setColumnDefs(updatedColumnDefs);
        }
    }

    onGridReady(params: { api: GridApi; columnApi: ColumnApi }): void {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;

        this.gridApi.sizeColumnsToFit();
        this.columnApi.applyColumnState({
            state: [
                { colId: 'Date', sort: 'desc', sortIndex: 0 },
                { colId: 'Unit', sort: 'asc', sortIndex: 1 },
            ],
        });
    }

    beforeDestroy(): void {
        // Cleanup event listener
        EventBus.$off(EventBus.GLOBAL.LANGUAGE_CHANGED);
    }
}
